import * as React from 'react';
import styled from 'styled-components';

import { ImageCDNProvider, ModuleTeaser } from '@packages/common';
import { Button, media } from '@packages/ui';

import { TeaserItem, TeaserItemProps } from '../TeaserItem/TeaserItem';
import { HeadlineWithPaddingBottom } from '../Headline/Headline';
import { List, ListLi, ListUl } from '../../List/List';
import { moduleMargin } from '../utils';
import { CallToAction } from '../CallToAction/CallToAction';

export const Container = styled.div`
  box-sizing: border-box;
  ${moduleMargin};
  padding: 0 8px;

  ${ListUl} {
    list-style-type: none;
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    margin: -24px -4px;
  }

  ${ListLi} {
    width: ${100 / 2}%;
    padding: 24px 4px;
  }

  ${media.from.md`
    padding: 0;
  
    ${ListUl} {
      margin: -24px -8px;
    }
    ${ListLi} {
      width: ${100 / 4}%;
      padding: 24px 8px;
      display: block;
    } 
  `};
`;

export const A = styled(Button)``.withComponent('a');

export const CallToActionContainer = styled.div.attrs({ 'data-testid': 'cms-teaser-cta-container' })`
  margin-top: 24px;
  display: block;
  text-align: center;

  ${A} {
    border-radius: 6px;
    display: inline-block;
  }

  ${media.from.lg`
    margin-top: 32px; 
  `};

  ${media.from.xl`
    margin-top: 40px; 
  `};
`;

export type TeaserProps = ModuleTeaser;

export class Teaser extends React.PureComponent<TeaserProps & { cdnProvider: ImageCDNProvider }> {
  renderItem = ({ item }: { item: TeaserItemProps }): React.ReactElement<TeaserItem> => {
    return <TeaserItem key={item.id} {...item} />;
  };

  render() {
    const { title, items, cta, cdnProvider } = this.props;

    return (
      <Container>
        <HeadlineWithPaddingBottom pb={[3, 3, 5]}>{title}</HeadlineWithPaddingBottom>
        <List
          items={items.map((item) => ({
            ...item,
            cdnProvider,
          }))}
          renderItem={this.renderItem}
        />
        {cta && (
          <CallToActionContainer>
            <CallToAction {...cta} as={A}>
              {cta.title}
            </CallToAction>
          </CallToActionContainer>
        )}
      </Container>
    );
  }
}
